import React from "react";
import { useRouteMatch, Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { GET_ROLES } from "graphql/query/role-gql";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import UserGroups from 'components/usergroup';
import { Localize } from "components/service";


const basePath = UserGroups.Const.basePath;
const UserGroupsPage = ({ canManageUserGroups = false }) => {

    useActiveMenuItem([ "users" ], [ "users" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_UserGroups" }).props.children,
            path: `${ basePath }`
        }
    ]

    useBreadCrumbs(breadcrumbs);

    let match = useRouteMatch(`${ basePath }/page/:pageNum`);
    const tableHelper = UserGroups.Helpers.TableMain(canManageUserGroups);


    const pageNavbar = [
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_Users" }).props.children,
            path: "users"
        },

        {
            label: Localize({ children: "NAVBAR_PAGES.Label_UserGroups" }).props.children,
            path: "user-groups"
        } ];


    return (
        <PageWrapDefault
            className="page-user-groups"
            dataExist={ true }
            title={ <Localize>PAGES.Title_UserGroups</Localize> }
            pageNavbar={ pageNavbar }
            staticPath=""
        >
            <Tables.Main
                model="roles"
                query={ GET_ROLES }
                varSet={ { perPage: 30 } }
                routeUrl={ `${ basePath }` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText=""
                objFilter={ {} }
                objOrderBy={ [ { column: "ID", order: "ASC" } ] }
                tableHelper={ tableHelper }
            >
                { canManageUserGroups && <div className="table-action-bar">

                    <div className="col">
                        <Link
                            className="ant-btn ant-btn-primary"
                            type="primary"
                            to={ `${ basePath }/create` }
                        >
                            <PlusOutlined /> <Localize>GROUP.Button_Text_Create</Localize>
                        </Link>
                    </div>

                </div> }

            </Tables.Main>
        </PageWrapDefault>
    )
};

export default UserGroupsPage;
